import type { OAuthConsentTranslations } from '../interfaces/oauth';

export const oauthTranslations: OAuthConsentTranslations = {
  title: 'Authorize access',
  subtitle: '{{client}} is requesting access to your {{brand}} account.',
  scopeSectionLabel: 'Requested permissions',
  scopeMcpDescription:
    'Use {{brand}} MCP tools on your behalf (read and run actions from your account).',
  loggedInAs: 'Signed in as',
  allowButton: 'Allow access',
  denyButton: 'Deny',
  deniedTitle: 'Access denied',
  deniedMessage: 'You did not authorize the connection. No access was granted.',
  closeWindowHint: 'You can now close this window.',
  invalidRequestTitle: 'Invalid request',
  invalidRequestMessage:
    'This authorization request is invalid or has expired. Please start the process again from your application.',
  backToApp: 'Go to {{brand}}',
  approveErrorToast: 'Could not complete the authorization. Please try again.',
  loading: 'Loading request…',
};
